"use strict";var $floor=Math.floor;module.exports=function(x){return"bigint"==typeof x?x:$floor(x)};